import {
  Button,
  colors,
  List,
  ListItem
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { NavLink as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': { color: theme.palette.primary.main }
  }
}));

/* Wrapper para o NavLink funcionar como componente do Button do MUI */
const CustomRouterLink = forwardRef((props, ref) => (
  <div
    ref={ref}
    style={{ flexGrow: 1 }}
  >
    <RouterLink
      {...props}
    />
  </div>
));

/* Menu lateral simples, sem permissões */
const SidebarNav = (props) => {
  const {
    className,
    pages,
    ...rest
  } = props;

  const classes = useStyles();

  return (
    <List
      {...rest}
      className={clsx(
        classes.root,
        className
      )}
    >
      {pages.map((page) => (
        <ListItem
          className={classes.item}
          disableGutters
          key={page.href}
        >
          <Button
            activeClassName={classes.active}
            className={classes.button}
            component={CustomRouterLink}
            to={page.href}
          >
            <div className={classes.icon}>
              {page.icon}
            </div>

            {page.title}
          </Button>
        </ListItem>
      ))}
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array.isRequired
};

export default SidebarNav;